import { Component, Input } from '@angular/core';
import { IconBadge } from '@core/services/room-details/room-details.service';
import { MealPlan } from '@core/models/MealPlan/meal-plan.enum';
import { MbIconTextModule, MbIconModule } from '@am/moebius';


@Component({
    selector: 'am-meal-plans',
    templateUrl: './meal-plans.component.html',
    styleUrls: ['./meal-plans.component.scss'],
    standalone: true,
    imports: [
        MbIconTextModule,
        MbIconModule,
    ],
})
export class MealPlansComponent {
  @Input()
  mealPlansBadges: IconBadge<MealPlan>[];

  constructor() {}
}
